import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { FundraiserService } from '../../../../services/fundraiser.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { QuillEditorComponent } from '../../../../../../shared/components/quill-editor/quill-editor.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatButtonModule } from '@angular/material/button';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgIf, NgTemplateOutlet, NgFor, UpperCasePipe, TitleCasePipe } from '@angular/common';

type LOCALE =
	| 'nl'
	| 'en'
	| 'es'
	| 'de'
	| 'fr'
	| 'bg'
	| 'hr'
	| 'cs'
	| 'da'
	| 'fi'
	| 'el'
	| 'hu'
	| 'it'
	| 'pl'
	| 'pt'
	| 'ro'
	| 'sk'
	| 'sv'
	| 'uk';
type NEW_CONTENT = {
	[key in LOCALE as string]?: string;
};
@Component({
    selector: 'app-translate-updates',
    templateUrl: './translate-updates.component.html',
    standalone: true,
    imports: [NgClass, ExtendedModule, MatButtonModule, FlexModule, NgIf, MatProgressSpinnerModule, MatDialogModule, MatFormFieldModule, QuillEditorComponent, NgTemplateOutlet, MatIconModule, MatMenuModule, NgFor, UpperCasePipe, TitleCasePipe]
})
export class TranslateUpdatesComponent implements OnInit {
	allLocales: LOCALE[] = [
		'nl',
		'en',
		'es',
		'de',
		'fr',
		'bg',
		'hr',
		'cs',
		'da',
		'fi',
		'el',
		'hu',
		'it',
		'pl',
		'pt',
		'ro',
		'sk',
		'sv',
		'uk',
	];
	allLanguages = {
		bg: 'Bulgarian',
		hr: 'Croatian',
		cs: 'Czech',
		da: 'Danish',
		fi: 'Finnish',
		el: 'Greek',
		hu: 'Hungarian',
		it: 'Italian',
		pl: 'Polish',
		pt: 'Portuguese',
		ro: 'Romanian',
		sk: 'Slovak',
		sv: 'Swedish',
		uk: 'Ukrainian',
		nl: 'Dutch',
		de: 'Deutsch',
		es: 'Spanish',
		en: 'English',
		fr: 'French',
	};
	originalLocale: LOCALE = 'nl';
	selectedLocale: LOCALE = 'en';
	languageIconPath: string =
		'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/';
	translationLocaleArr: LOCALE[] = [];

	originalQuillContent!: any;
	quillContentCtrl: UntypedFormControl = new UntypedFormControl();
	quillContent!: any;
	isLoading: boolean = false;
	isDisable: boolean = true;
	isAutoTranslating: boolean = false;
	newContent: NEW_CONTENT[] = [
		{ nl: '' },
		{ en: '' },
		{ es: '' },
		{ de: '' },
		{ fr: '' },
		{ fi: '' },
		{ hr: '' },
		{ hu: '' },
		{ it: '' },
		{ pl: '' },
		{ pt: '' },
		{ ro: '' },
		{ sk: '' },
		{ sv: '' },
		{ uk: '' },
		{ bg: '' },
		{ cs: '' },
		{ da: '' },
		{ el: '' },
	];
	allTextCheck: boolean = false;
	loadingText: boolean = false;
	constructor(
		private notificationService: NotificationService,
		public _fundraiserService: FundraiserService,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			slug: any;
			update: any;
			locale: any;
		},
		public dialogRef: MatDialogRef<TranslateUpdatesComponent>
	) {}

	ngOnInit(): void {
		this.originalLocale = this.data?.locale;
		this.originalQuillContent = this.data?.update?.content;
		this.translationLocaleArr = this.getTranslatableLocale(this.originalLocale);
		this.setQuillContent();
	}
	/** when content is edited of any locale, it is updated to newContent */
	changeUpdateContent(event: any) {
		this.newContent.map((content) => {
			if (content[this.selectedLocale] !== undefined) {
				content[this.selectedLocale] = event;
			}
			return content;
		});
		this.isDisable = false;
	}
	/** Remove all saved content */
	discardAllContentChanges() {
		this.quillContentCtrl.setValue(this.quillContent);

		this.newContent = this.newContent.map((content) => {
			return Object.assign({ [Object.keys(content)[0]]: '' });
		});
		this.changeQuillContent(this.selectedLocale);
		this.isDisable = true;
	}
	changeLanguage(language: string) {
		switch (true) {
			case language.includes('nl'):
				this.selectedLocale = 'nl';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('es'):
				this.selectedLocale = 'es';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('de'):
				this.selectedLocale = 'de';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('fr'):
				this.selectedLocale = 'fr';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('bg'):
				this.selectedLocale = 'bg';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('hr'):
				this.selectedLocale = 'hr';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('cs'):
				this.selectedLocale = 'cs';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('da'):
				this.selectedLocale = 'da';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('fi'):
				this.selectedLocale = 'fi';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('el'):
				this.selectedLocale = 'el';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('hu'):
				this.selectedLocale = 'hu';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('it'):
				this.selectedLocale = 'it';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('pl'):
				this.selectedLocale = 'pl';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('pt'):
				this.selectedLocale = 'pt';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('ro'):
				this.selectedLocale = 'ro';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('sk'):
				this.selectedLocale = 'sk';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('sv'):
				this.selectedLocale = 'sv';
				this.changeQuillContent(this.selectedLocale);
				break;
			case language.includes('uk'):
				this.selectedLocale = 'uk';
				this.changeQuillContent(this.selectedLocale);
				break;
			default:
				this.selectedLocale = 'en';
				this.changeQuillContent(this.selectedLocale);
		}
	}
	changeQuillContent(selectedLocale: LOCALE) {
		// if edited content already exist for a locale then prefer that
		let editedContent = this.newContent.find(
			(content) => content[selectedLocale]
		)?.[selectedLocale];

		this.quillContent =
			editedContent ||
			this.data?.update?.translation['content_' + selectedLocale];
	}
	setQuillContent() {
		this.quillContent =
			this.data?.update?.translation['content_' + this.translationLocaleArr[0]];

		this.selectedLocale = this.translationLocaleArr[0];
	}
	getOriginalLocale() {
		return this.originalLocale;
	}
	getTranslatableLocale(originalLocale: LOCALE): LOCALE[] {
		return this.allLocales.filter((locale) => locale !== originalLocale);
	}
	getLanguage(locale: LOCALE) {
		return this.allLanguages[locale];
	}

	autoTranslate() {
		if (this.selectedLocale) {
			let body = {
				content: this.originalQuillContent,
				target_language: this.selectedLocale,
				source_language: this.originalLocale,
			};
			this.isAutoTranslating = true;
			this._fundraiserService.autoTranslateNew(body).subscribe(
				(response: any) => {
					this.quillContentCtrl.setValue(response?.data?.translated_text);
					this.changeUpdateContent(response?.data?.translated_text);
					this.isAutoTranslating = false;
				},
				(error) => {
					this.notificationService.openNotification(
						$localize`:@@translate_about_autoTranslating_notification:There was an error Auto Translating Fundraiser About`,
						'',
						'error'
					);
					this.isAutoTranslating = false;
				}
			);
		}
	}
	allCheck(event: boolean) {
		this.allTextCheck = event;
	}
	saveTranslations() {
		this.isLoading = true;
		let editedContent = this.newContent.filter((content: NEW_CONTENT) => {
			return !!content[Object.keys(content)[0]];
		});
		let observableSourceList: any = [];

		editedContent.map((content) => {
			let contentBody: any = {};
			contentBody['content'] = Object.values(content)?.[0];

			// Process the content to replace <ul> and its <li> children
			contentBody.content = contentBody.content
				.replace(
					/<ul>(.*?)<\/ul>/gs,
					(match: string, innerContent: string): string => {
						return innerContent.replace(
							/<li>(.*?)<\/li>/g,
							'&#8226;&nbsp;$1<br>' // Replace <li> inside <ul> with bullet points
						);
					}
				)
				.replace(
					/<ol>(.*?)<\/ol>/gs,
					(match: string, innerContent: string): string => {
						let index = 1; // Start numbering from 1
						return innerContent.replace(
							/<li>(.*?)<\/li>/g,
							(_, item: string): string => {
								return `${index++}.&nbsp;${item}<br>`; // Replace <li> inside <ol> with numbered list
							}
						);
					}
				);

			// Sanitize the content using DOMPurify
			// const DOMPurify = require('dompurify');
			// contentBody.content = DOMPurify.sanitize(contentBody.content);

			contentBody['update_id'] = this.data?.update?.id;
			contentBody['language_code'] = Object.keys(content)?.[0];
			contentBody['is_auto'] = false;
			contentBody['slug'] = this.data?.slug;

			// Push the transformed content to observable source list
			observableSourceList.push(
				this._fundraiserService.saveUpdates(contentBody)
			);
		});

		// Execute the observable list
		forkJoin(observableSourceList).subscribe(
			(results) => {
				this.isLoading = false;
				this.dialogRef.close(true);
				this.notificationService.openNotification(
					$localize`:@@fundraiser_update_edit_updateRequired_notification:Fundraiser Update is translated`,
					'',
					'success'
				);
				window.location.reload();
			},
			(err: any) => {
				this.notificationService.openNotification(
					$localize`:@@translate_appeal_errorTranslatingFundraiser_notification:There was an error Translating Fundraiser Update`,
					'close',
					'error'
				);
				this.isLoading = false;
			}
		);
	}

	onCloseClick() {
		this.dialogRef.close();
	}
	handlePasteDetected(loader: boolean) {
		this.loadingText = loader;
	}
}
